import React from "react";

import { formatBalance, getBalanceColor } from "../../utils/balance";
import { formatPercentage } from "../../utils/number";
import { Tag } from "../Tag";

interface PercentChangeTagProps {
  value: number;
  reverseNegativeColors?: boolean;
}

export const PercentChangeTag: React.FC<PercentChangeTagProps> = ({ value, reverseNegativeColors = false }) => {
  const color = getBalanceColor(value, reverseNegativeColors);
  const label = formatBalance(value, formatPercentage);

  return <Tag label={label} color={color} />;
};
